export const getRelativeTime = (dateString: string, language: string = 'en'): string => {
    const utcDateString = dateString.includes('Z') ? dateString : `${dateString}Z`;
    const date = new Date(utcDateString);
    const now = new Date();
    const elapsed = now.getTime() - date.getTime();

    const rtf = new Intl.RelativeTimeFormat(language, { numeric: 'auto' });

    const seconds = Math.floor(elapsed / 1000);
    const minutes = Math.floor(elapsed / 60000);
    const hours = Math.floor(elapsed / 3600000);
    const days = Math.floor(elapsed / 86400000);
    const weeks = Math.floor(elapsed / 604800000);
    const months = Math.floor(elapsed / 2592000000);
    const years = Math.floor(elapsed / 31536000000);

    // if (seconds < 60) return "Just now";
    if (seconds < 60)return rtf.format(-seconds, 'second');
    if (minutes < 60) return rtf.format(-minutes, 'minute');
    if (hours < 24) return rtf.format(-hours, 'hour');
    if (days < 7) return rtf.format(-days, 'day');
    if (weeks < 4) return rtf.format(-weeks, 'week');
    if (months < 12) return rtf.format(-months, 'month');
    return rtf.format(-years, 'year');
};
